import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from '../../actions';
import { __, setLocale } from 'i18n-for-browser';

/*
* Import components
 */
import Loading from '../elements/Loading';
import Visible from '../../assets/img/icons/visible.png';
import Invisible from '../../assets/img/icons/invisible.png';
import LoginLogo from '../../assets/img/login-logo.png';
import apiCall from '../../components/apiCall';
import PopUp from '../elements/PopUp';

const { login } = actions.user;

class Login extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };
  constructor(props) {
    setLocale("en");
    super(props);
    this.state = {
      user: this.props.user,
      username: '',
      password: '',
      loginFailed: false,
      passwordVisibility: false,
      alreadyLoggedIn: false,
      loggedOutBySomeoneElse: sessionStorage.getItem('tweedeinlog') === 'true',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const token = new URL(window.location.href).searchParams.get('token');

    /**
     * NOTE: Here we make the assumption that only admin's / classleaders use a token in the URL to log in.
     * This is the case, but keep this in mind when something has to be implemented which would invalidate this.
     */
    if (token) {
      sessionStorage.setItem('governAsClassleader', true);
      this.props.dispatch(login(null, null, token));
    }
  }

  componentWillReceiveProps({ user }) {
    this.setState({ user: user });
  }

  handleRedirect = () => {
    const redirect = new URL(window.location.href).searchParams.get('redirect');
    if (redirect) {
      return window.location.href = redirect;
    }
    window.location.href = '/portal';
  };

  /**
   * Method to handle on change events for input elements
   */
  handleChange = (ev) => {
    const { target } = ev;
    const { value, name } = target;
    this.setState({
      [name]: value,
      loading: false,
      loginFailed: false,
    });
  };

  /**
   * Method to handle login form submit
   */
  handleSubmit = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    const { username, password } = this.state;
    if (!username || !password) return false;
    apiCall('/user/alreadyLoggedIn', { username, password }, 'POST')
      .then(({ alreadyLoggedIn, lang }) => {
        if (lang) {
          setLocale(lang);
        }
        if (!alreadyLoggedIn) {
          this.handleLogin();
        }
        this.setState({ alreadyLoggedIn });
      })
      .catch((err) => {
        console.warn(err);
      });
    return false;
    // this.handleLogin();
  };

  handleLogin = () => {
    sessionStorage.removeItem('redirect');
    sessionStorage.removeItem('prevLocation');
    sessionStorage.removeItem('noMobile');
    this.setState({loading: true, alreadyLoggedIn: false});

    const { username, password } = this.state;

    this.props.dispatch(login(username, password))
      .then((result) => {
        if (!result) {
          this.setState({
            loginFailed: true,
            loading: false
          })
        } else {
          this.setState({
            loginFailed: false,
            loading: false
          })
        }})
  };

  render() {
    const { state } = this;

    if (this.props.user.loggedIn) {
      this.handleRedirect();
      return null;
    }

    return (
      <div className="login-parent">
        <div className="login-container">
          <img className="login-logo" src={LoginLogo} alt="Globaland XL Logo" />
          <form action="/login" method="post" className="content-container" onSubmit={this.handleSubmit}>
            <div className="content-container-background"/>

            <div className="input-container">
              <input type="text" placeholder={__("sim_gebruikersnaam")} name="username" onChange={this.handleChange} value={this.state.username} />
            </div>
            <div className="input-container">
              <input name="password" placeholder={__("sim_wachtwoord")} type={this.state.passwordVisibility ? 'text' : 'password'} onChange={this.handleChange} value={this.state.password} />
              <span
                className="password-visibility-container"
                style={{
                  background: 'transparent',
                  height: '40px',
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  borderRadius: '16px',
                  display: 'flex',
                  padding: 8
                }}
              >
                <img
                  src={this.state.passwordVisibility ? Visible : Invisible}
                  alt="toggle visibility"
                  onClick={() => { this.setState({ passwordVisibility: !this.state.passwordVisibility }); }}
                  style={{
                    width: '20px',
                    justifySelf: 'center',
                    alignSelf: 'center',
                    cursor: 'pointer',
                  }}
                />
              </span>

              { state.loginFailed ? (
                <div className="login-failed">
                  {__('sim_inloggegevens_niet_correct_melding')}
                </div>
              ) : null }
            </div>

            <button type="submit"><span>{__('sim_inloggen')}</span></button>
          </form>
        </div>
        {state.alreadyLoggedIn ? (
          <PopUp id={'dlgmtweedeinlog'} closePopUpClick={(res) => {
            if (res) {
              return this.handleLogin();
            }
            this.setState({ alreadyLoggedIn: false });
          }}/>
        ) : null}
        { state.loading ? (
          <Loading />
        ) : null }
        {
          state.loggedOutBySomeoneElse ? (
            <PopUp
              id={'dlgmtweedeinlog_1'}
              showPopUp={true}
              closePopUpClick={() => { sessionStorage.setItem('tweedeinlog', ''); this.setState({ loggedOutBySomeoneElse: false }); }}
            />
          ) : null
        }
      </div>
    );
  }
}

export default connect(user => user)(Login);



// WEBPACK FOOTER //
// ./src/components/routes/Login.js